"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealVkusvillOrmlLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealVkusvillOrmlLinear = function MealVkusvillOrmlLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.787 16.199l.24.151.284.002c3.694.029 6.677 1.174 8.72 2.524 1.025.677 1.797 1.394 2.302 2.027.536.675.667 1.123.667 1.275 0 .131-.073.448-.369.93-.283.46-.723.995-1.324 1.54-1.2 1.09-2.99 2.178-5.284 2.807-4.503 1.234-11.075.727-19.073-5.28.506-.397.955-.768 1.377-1.116 1.331-1.097 2.389-1.969 4.073-2.732l.646-.292-.063-.707c-.136-1.525.136-2.328.454-2.735.292-.373.767-.592 1.533-.593.782 0 1.748.233 2.794.645 1.035.408 2.087.966 3.023 1.554zM8.324 22.175l-.049.074c-.407.624-1.076 1.067-1.96 1.549a38.05 38.05 0 01-.395.21c-.54.287-1.157.614-1.702 1.017a18.938 18.938 0 01-.002-5.717c.49.363 1.025.641 1.501.889.133.07.262.136.384.202.787.425 1.54.904 2.223 1.776zm20.949.437a2.433 2.433 0 003.13-.315 2.539 2.539 0 00.303-3.143 2.472 2.472 0 00-1.102-.93 2.423 2.423 0 00-1.438-.146 2.45 2.45 0 00-1.266.695 2.522 2.522 0 00-.664 1.279 2.55 2.55 0 00.137 1.433c.183.455.494.848.9 1.127z",
    stroke: "#95A0B3",
    strokeWidth: 2
  }));
};

exports.MealVkusvillOrmlLinear = MealVkusvillOrmlLinear;
var _default = MealVkusvillOrmlLinear;
exports.default = _default;